import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '@app/network/apiClient';
import { timezoneUrl } from '@app/definition/API';

const fetchTimezone = createAsyncThunk(
  'timezone/fetchTimezone',
  async (countryCode: string) => {
    try {
      const url = timezoneUrl.replace('%country_code%', countryCode);
      const response = await apiClient(url);

      if (response.status >= 400) {
        throw new Error(response.data.message || 'Invalid response!');
      }

      return response.data.data || [];
    } catch (error) {
      throw new Error(error as string);
    }
  }
);

export default fetchTimezone;
